<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <div class="container">
      <router-link class="navbar-brand" to="/">
        <img alt="Juniti" src="@/assets/Logo-white.svg">
      </router-link>
      <div style="color: white">{{ accountInfos.firstName }} {{ accountInfos.lastName }}, {{ backofficeRoleFormatted }} </div>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav">
          <li>
            <a href="#" class="nav-link" @click="logout">Abmelden</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import {getBackofficeRole, logout} from "@/util/authenticator.js";
import {broadcast} from "@/util/eventHandler";

export default {
  name: "NavBar",
  methods: {
    logout: logout,
    async fetchAccount() {
      console.log("Load account infos...");
      try {
        await this.$store.dispatch("FETCH_ACCOUNTINFOS");
        this.backofficeRole = getBackofficeRole();
      } catch (e) {
        broadcast("error", e);
      }
    }
  },
  created() {
    // this.fetchAccount();
    this.backofficeRole = getBackofficeRole();
  },
  data() {
    return {
      backofficeRole: "",
      navRoutes: []
    };
  },
  computed: {
    accountInfos() {
      return this.$store.state.accountInfos;
    },
    backofficeRoleFormatted() {
      if(this.backofficeRole === "super-admin") return "Super Admin (Internationaler Bund)";
      else if(this.backofficeRole === "admin") {
        const name = this.$store.state.organisations[0] ? " (" + this.$store.state.organisations[0].name + ")" : "";
        return "Admin" + name;
      }
      else if(this.backofficeRole === "manager") {
        const name = this.$store.state.locations[0] ? " (" + this.$store.state.locations[0].name + ")" : "";
        return "Verwalter" + name;
      }
      else if(this.backofficeRole === "community-manager") return "Community Manager";
      else return "";
    }
  }
};
</script>

<style scoped>

.navbar.navbar-dark.bg-dark {
  border-radius: 0;
  background-color: #5B41E1 !important;

  a {
    color: white;
  }
}

.navbar-brand img {
  height: 24px;
}

.nav.navbar-nav li.active a {
  background-color: rgba(0, 0, 0, 0.1);
}

.navbar-collapse {
  flex-grow: inherit;
}
</style>
